import moment from 'moment'
import units from '@/sui/data/units'
import { resistanceFilterVariables } from '@/sui/sc/microCaracteristics'
import micro from '@/sui/data/microOrgs'

function field (k, f, n, c) {
  return { key: k, field: (s) => [s[f]], name: n, characs: c }
}

function itbfield (k, f, n, c) {
  return {
    key: k,
    field: (s) => {
      if (s.itb == null) {
        return []
      }
      return [s.itb[f]]
    },
    name: n,
    characs: c
  }
}

function patfield (k, f, n, c) {
  return { key: k, field: (s) => [s.pat[f]], name: n, characs: c }
}

function inffield (k, f, n, c) {
  return { key: k, field: (s) => [s.inf[f]], name: n, characs: c }
}

function severity (v) {
  return {
    key: v,
    field: (s) => {
      if (s.pat.mainSeverity.code === v) {
        return [s.pat.mainSeverity.value]
      }
      return []
    },
    name: `Score de sévérité ${v.toUpperCase()}`
  }
}

function computeLapse (s, bf, ef, d) {
  const b = moment(bf(s)).hour(12)
  const e = moment(ef(s)).hour(12)
  if (b.year() === 1 || e.year() === 1) {
    return []
  }
  return [e.diff(b, d)]
}

function itblapse (k, bf, ef, d, n) {
  return {
    key: k,
    field: (s) => {
      if (s.itb == null) {
        return []
      }
      return computeLapse(s, bf, ef, d)
    },
    name: n
  }
}

function lapse (k, bf, ef, d, n) {
  return {
    key: k,
    field: (s) => computeLapse(s, bf, ef, d),
    name: n
  }
}

export default {
  filterVariables: function (year) {
    return [

      field('protocol', 'prot', `Protocole d'origine de l'infection`),
      {
        key: 'type',
        field: (s) => [s.itb == null ? 'bact' : 'pneu'],
        name: `Type d'infection (bact ou pneu)`
      },
      patfield(
        'sexe', 'sex', 'Sexe du patient', ['sex']
      ),
      lapse(
        'age', s => s.pat.birthdate, s => s.inf.episod, 'years',
        `Âge du patient au moment de l'épisode (en années)`
      ),
      lapse(
        'neoage', s => s.pat.birthdate, s => s.inf.episod, 'days',
        `Âge du patient au moment de l'épisode (en jours)`
      ),
      {
        key: 'origine',
        name: 'Provenance du patient adulte ou enfant',
        field: (s) => s.pat.birthWeight != null ? [] : [s.pat.origin],
        characs: ['origin']
      },
      {
        key: 'neoorigine',
        name: 'Provenance du patient nouveau-né',
        field: (s) => s.pat.birthWeight != null ? [s.pat.origin] : [],
        characs: ['neoOrigin']
      },
      patfield('immuno', 'immuno', 'Immunodépression', ['immuno']),
      patfield('cancer', 'cancer', 'Cancer évolutif', ['cancer']),
      patfield('trauma', 'trauma', 'Patient traumatisé', ['trauma']),
      patfield('diagnosis', 'diagnosis', 'Catégorie diagnostique patient', ['diagnosis']),
      patfield('antibio', 'antibio', `Antibiotique à l'admission`, ['antibio']),
      patfield('imc', 'bmi', `IMC`),
      patfield('bmr', 'portageBmrBhre', `Portage BMR / BHRe`, ['portageBmrBhre']),
      itbfield('ecmo', 'ecmo', 'ECMO', ['ecmo']),
      itbfield('intub', 'intubated', 'Patient intubé', ['intubated']),
      itbfield('reintub', 'reintubated', 'Patient réintubé', ['reintubated']),
      patfield('poids', 'birthWeight', 'Poids de naissance'),
      patfield('ageg', 'gestationalAge', 'Âge gestationnel'),
      patfield('décès', 'dead', 'Décès à 7 jours', ['dead']),
      severity('igsII'),
      severity('pimII'),
      severity('cribII'),
      inffield('covid', 'covidStatus', 'Statut COVID', ['covidStatus']),
      inffield('acquise', 'origin', `Origine de l'infection`, ['origin']),
      {
        key: 'acqservice',
        name: 'Acquise dans le service (1. Oui, 2. Non hors étab, 3. Non <48h)',
        field: (s) => {
          if (s.inf.origin === 1 || s.inf.origin === 2) {
            return [1]
          } else if (s.inf.origin !== 9) {
            return [2]
          }

          const e = moment(s.inf.episod).hour(12)
          const b = moment(s.pat.entry).hour(12)
          if (b.year() === 1 || e.year() === 1) {
            return []
          }
          const d = e.diff(b, 'days')
          if (d < 2) {
            return [3]
          }

          return [1]
        }
      },
      inffield(
        'pe', 'entrance_v2',
        `Porte d'entrée. Pour les pneumopathies P1 si associées à l'intubation P2 sinon.`,
        ['entrance']
      ),
      inffield('lipides', 'lipids', 'Lipides ou alimentation parentérale', ['lipids']),
      inffield('site', 'insertionSite', 'Site de pose', ['insertionSite']),
      inffield('ktr', 'removed', 'Retrait du cathéter', ['removed']),
      lapse(
        'ktinfdélai', s => s.inf.insertion, s => s.inf.episod, 'days',
        `Date de l'épisode - date de pose du cathéter`
      ),
      itblapse(
        'intubdurée', s => s.itb.intubStart, s => s.itb.intubEnd, 'days',
        `Date de fin de l'intubation - date de début`
      ),
      lapse(
        'ktdurée', s => s.inf.insertion, s => s.inf.removal, 'days',
        `Date de retrait du cathéter - date de pose`
      ),
      {
        key: 'mo',
        name: 'Micro-organisme',
        field: (s) => {
          const result = []
          s.inf.microOrganisms.forEach(
            mo => {
              result.push(
                micro.completeList.v2.find(e => e.index === mo.code).code
              )
            }
          )
          return result
        }
      },
      ...resistanceFilterVariables(
        year,
        (s) => s.inf.microOrganisms
      ),
      {
        key: 'spe',
        name: 'Spécialité',
        field: (s) => {
          return [units[year].codeFromIndex(s.uf.ufType)]
        }
      },
      {
        key: 'uf',
        name: 'Uf',
        field: s => [s.uf.name]
      },
      inffield(
        'divdiag', 'divDiag',
        `Critère diagnostique pour les PE DIV (adulte et enfant)`,
        ['divDiag']
      ),
      inffield(
        'neodivdiag', 'neoDivDiag',
        `Critère diagnostique pour les PE DIV (nouveau-né)`,
        ['neoDivDiag']
      ),
      inffield(
        'a4uri', 'urinaryPresent',
        `Sondage urinaire dans les 7 jours avant l'épisode`,
        ['urinaryPresent']
      ),
      inffield(
        'a4uridiag', 'urinaryDiag',
        'Critère diagnostique pour les PE urinaire (A4)',
        ['urinaryDiag']
      ),
      inffield(
        'a3intub', 'bactintubated',
        `Patient intubé pour une PE pleuro-pulmonaire (A3)`,
        ['a3intubated']
      ),
      inffield(
        'a13kt', 'catheter',
        `Présence d'un cathéter si PE non retrouvée (A13)`,
        ['catheter']
      ),
      inffield(
        'a13typekt', 'catheterType_v2',
        `Type de catheter présent si PE non retrouvée (A13)`,
        ['catheterType']
      ),
      inffield(
        'pneudiag', 'diagnosis', `Critère diagnostique des pneumopathies`,
        ['diagnosis']
      ),
      {
        key: 'id',
        name: `Identifiant de la fiche à partir de laquelle l'infection a été extraite`,
        field: (s) => [s.sheet.id]
      }
    ]
  }
}
